import { Box, Skeleton } from "@mui/material";

export const TableLoadingOverlay = ({ columnsCount, rowHeight = 45, rowCount = 8 }) => {
	return (
		<Box
			sx={{
				position: "absolute",
				inset: 0,
				zIndex: 2,
				backgroundColor: "rgba(255,255,255,0.6)",
				backdropFilter: "blur(1px)",
				pointerEvents: "none",
			}}>
			{Array.from({ length: rowCount }).map((_, rowIdx) => (
				<Box
					key={rowIdx}
					sx={{
						display: "flex",
						alignItems: "center",
						height: rowHeight,
						px: 1,
					}}>
					{Array.from({ length: columnsCount }).map((_, colIdx) => (
						<Box key={colIdx} sx={{ flex: 1, px: 0.5, height: "100%" }}>
							<Skeleton height="90%" />
						</Box>
					))}
				</Box>
			))}
		</Box>
	);
};
